import React, { Component } from 'react';
import PlayButton from './playButton';
import scrollImage from '../images/scroll-image.jpg';
import typeWriter from '../images/typewriter.png';
import learnButton from '../images/learn-button.png';
import manImage from '../images/man.jpg';
import workButton from '../images/work-button.png';
import peerlessPlaten from '../images/Peerless_Platen.png';
import wharfDale from '../images/Wharfedale.png';
import shawPen from '../images/ShawPen.png';

class Tile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      playVideo: false,
    };
  }

  render() {
    const { title, subTitle, text, bg, type, bold, textEnd, textStart } = this.props;
    let image;
    this.props.titleImage ?  image = require(`../images/${this.props.titleImage}`) : image = null
    let backgroundImage =  require(`../images/${bg}`)
    
    backgroundImage = bg === 'shaw' ?  manImage : backgroundImage;
    return (
      <div
        className="tile"
        style={{
          backgroundImage:
           'url(' +
            backgroundImage +
            ')',
        }}
      >
  
        <div className="info">
        
         <img src={ image ? image : bg === 'man.jpg' ? shawPen : bg === 'typewriter.png' ? peerlessPlaten : wharfDale} />
         <b><p>{textStart}{bold}{subTitle}{textEnd}</p> </b>
          <p>{text}</p>
        </div>
      {type !=='wharf' ?   <div className="options">
          <div className="play">
            <div onClick={() => this.props.onPlay(bg === 'scroll-image.jpg' ? 2 : 0 )}>
             <img style={{width:'89px'}} src={workButton} />
            </div>
      
          </div>
        </div> : null }
      
        <div className="options">
          <div onClick={() => this.props.onPlay(bg === 'scroll-image.jpg' ? 2 : 1)} className="learn">
          <img style={{width:'75px'}} src={learnButton} />
       
          </div>
        </div>
      </div>
    );
  }
}

export default Tile;



// WEBPACK FOOTER //
// ./src/components/tile.js